import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Select,
  Offcanvas, OffcanvasHeader, OffcanvasBody,
  CardHeader,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  FormGroup,
  Label,
} from "reactstrap"
import FilterMenuContact from "./filter-menu"
import RsAdNew from "components/buttons/Adnew";
import CreateContact from "../forms/contact-create"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getContacts } from "../../../store/actions"
import Moment from 'react-moment';

import moment from 'moment';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import axios from "axios";
import { API_URL } from "helpers/app_url";
import RsAdNewV2 from "components/buttons/Adnew-v2";
import YearDropdown from "components/dropdowns/YearDropdown";
import { map } from "lodash";
class ContactAllReferral extends Component {
  constructor(props) {
    super(props)
    this.state = {
        referrals : []
    }

    this.toggleAddNew = this.toggleAddNew.bind(this);
  }
  toggleAddNew() {
    this.setState({ isAddNew: !this.state.isAddNew });

  }

  componentDidMount() {
    this.fetchReferral();
  }

  fetchReferral() {
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;

  axios.get(`${API_URL}Lead/allforagentreferralwithcontact`, {
    headers: { Authorization: `Bearer ${token}` },
     params: {
        agentId: localStorage.getItem('userId')
        }
  })
  .then(response => {
    this.setState({
      referrals: response.data || [], 
      isLoading: false,
    });
  })
  .catch(error => {
    console.error('Error fetching data from second API:', error);
    this.setState({ isLoading: false });
  });
}
  render() {
    const { gridLoading, isResponsive } = this.props;    
    const { referrals } = this.state;
    const settings = {
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
  };
    const months = moment.months(); 
     const lastSixMonths = Array.from({ length: 6 }, (_, i) =>
        moment().subtract(5 - i, 'months').format('MMMM')
    );
    const brColor = [{ borderBottom: '3px solid #0D6EFD' }, { borderBottom: '3px solid #198754' }, { borderBottom: '3px solid #0DCAF0' }, { borderBottom: '3px solid #AB2E3C' }, { borderBottom: '3px solid #FFC107' }];
   
  const allLocal = localStorage.getItem('localData')
        const localization = JSON.parse(allLocal);
 
    return (
      <React.Fragment>
        {gridLoading ? (
          <div className="rs-loader-overlay">
            <div className="rs-loader"></div>
          </div>
        ) : null}
        <ToastContainer autoClose={2000} />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Contact Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
            {/* <Row className="project-header">
              <Col sm="7">
                <Breadcrumbs title="Contacts" breadcrumbItem="Contact Activities" />
              </Col>
              <Col sm="5">
                <div className="pt-2 float-end mt-2">
                  <RsAdNew to="/contact/import-contact" className="btn btn-light btn-md me-2" iconClass="bx bx-download">Import Contact</RsAdNew>
                  <RsAdNew to="#" onClick={this.toggleAddNew} className="btn btn-light btn-md" iconClass="bx bx-plus-medical">Add New</RsAdNew>
                </div>
              </Col>
            </Row> */}
             <Card className="card-without-border">
            <CardHeader className="">
            <FilterMenuContact />
            </CardHeader>
            </Card>

            <Row>
              <Col sm="12">
                  <div className="mt-4 mb-4 ms-3">
                    <RsAdNewV2 to="#" onClick={this.toggleAddNew} className="btn-rs text-purple btn-md" iconClass="">View all referrals</RsAdNewV2>
                  </div>
                 
                <Card>
  <CardBody>
    <Row className="toHeadingRow">
      <Col sm="12">
        {isResponsive ? (
         
          <Accordion open={this.state.openMonth} toggle={(id) => this.setState({ openMonth: this.state.openMonth === id ? null : id })}>
            {lastSixMonths.map((month, index) => {
              const monthLeads = referrals.filter(
                (ref) => moment(ref.submittedDate).format("MMMM") === month
              );

              return (
                <AccordionItem key={index}>
                  <AccordionHeader
                    targetId={month}
                    style={brColor[index % brColor.length]}
                  >
                    {month} 
                    {/* ({monthLeads.length}) */}
                  </AccordionHeader>

                  <AccordionBody accordionId={month}>
                    <div className="container p-0">
                      {monthLeads.length > 0 ? (
                        monthLeads.map((lead, i) => (
                          <div className="mb-3 card custom-card" key={i}>
                            <div className="card-body">
                              <div className="">
                                <div className="float-end ms-2">
                                  <span className="badge rounded-pill badge-soft-success font-size-12">
                                    {lead.leadStatusId
                                      ? localization["LeadStatus_" + lead.leadStatusId]
                                      : "N/A"}
                                  </span>
                                </div>
                                <h5 className="card-title mb-2 lead-box-title">
                                  Name:{" "}
                                  <Link to={`/lead/lead-detail/${lead.id}/${lead.leadId}`}>
                                    {lead.firstName} {lead.lastName}
                                  </Link>
                                </h5>
                                <h6>
                                  By:{" "}
                                  <Link
                                    to={`/contact/contact-detail/${lead.referedByContact.id}/${lead.referedByContact.contactId}`}
                                  >
                                    {lead.referedByContact.firstName}{" "}
                                    {lead.referedByContact.lastName}
                                  </Link>
                                </h6>
                                <h6>
                                  Date: <Moment format="D MMM YYYY">{lead.submittedDate}</Moment>
                                </h6>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p className="text-muted ps-2">No referrals</p>
                      )}
                    </div>
                  </AccordionBody>
                </AccordionItem>
              );
            })}
          </Accordion>
        ) : (
         
          <Slider {...settings}>
            {lastSixMonths.map((month, index) => {
              const monthLeads = referrals.filter(
                (ref) => moment(ref.submittedDate).format("MMMM") === month
              );

              return (
                <div key={index}>
                  <div className="topHeading p-2" style={brColor[index % brColor.length]}>
                    <span className="sc-kEqXSa CIzYb">{month}</span>
                  </div>

                  <div className="container p-0">
                    {monthLeads.length > 0 ? (
                      monthLeads.map((lead, i) => (
                        <div className="mb-3 card custom-card" key={i}>
                          <div className="card-body">
                            <div className="">
                              <div className="float-end ms-2">
                                <span className="badge rounded-pill badge-soft-success font-size-12">
                                  {lead.leadStatusId
                                    ? localization["LeadStatus_" + lead.leadStatusId]
                                    : "N/A"}
                                </span>
                              </div>
                              <h5 className="card-title mb-2 lead-box-title">
                                Name:{" "}
                                <Link to={`/lead/lead-detail/${lead.id}/${lead.leadId}`}>
                                  {lead.firstName} {lead.lastName}
                                </Link>
                              </h5>
                              <h6>
                                By:{" "}
                                <Link
                                  to={`/contact/contact-detail/${lead.referedByContact.id}/${lead.referedByContact.contactId}`}
                                >
                                  {lead.referedByContact.firstName}{" "}
                                  {lead.referedByContact.lastName}
                                </Link>
                              </h6>
                              <h6>
                                Date: <Moment format="D MMM YYYY">{lead.submittedDate}</Moment>
                              </h6>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className="text-muted ps-2">No referrals</p>
                    )}
                  </div>
                </div>
              );
            })}
          </Slider>
        )}
      </Col>
    </Row>
  </CardBody>
</Card>

              </Col>
            </Row>
          </Container>
        </div>
        <Offcanvas
          isOpen={this.state.isAddNew}
          direction="end"
          toggle={this.toggleAddNew}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.toggleAddNew}>
         
          </OffcanvasHeader>
          <OffcanvasBody>
           <Row>
            <Col sm="2">
                <FormGroup>
                    <Label htmlFor="selYear">Select Year</Label>
                    <YearDropdown />
                  
                </FormGroup>
            </Col>
           </Row>
           <Row>
              <Col sm="12">
                <h6 className="mb-3">All referrals</h6>

                <table className="table">
                  <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Referred by</th>
                         <th>Date</th>
                      </tr>
                  </thead>
                  <tbody>
                    {map(referrals, (referral, key) => (
                    <tr key={key}>
                      <td>{key + 1}</td>
                       <td>{referral.firstName +" "+referral.lastName}</td>
                      <td>{referral?.referedByContact?.firstName +" "+referral?.referedByContact?.lastName}</td>
                        <td><Moment format="D MMM YYYY">{referral.submittedDate}</Moment></td>
                    </tr>
                      ))}
                  </tbody>
                </table>
              </Col>
           </Row>
          </OffcanvasBody>
        </Offcanvas>
      </React.Fragment>
    )
  }
}

ContactAllReferral.propTypes = {
  t: PropTypes.any,
  onGetAllContact: PropTypes.func,
  contacts: PropTypes.array,
  gridLoading: PropTypes.object,
  isResponsive:PropTypes.object
}

const mapStateToProps = ({ contact }) => (
  {
    gridLoading: contact.gridLoading,
    contacts: contact.contacts,
  })
const mapDispatchToProps = dispatch => ({
  onGetAllContact: (agentId) => dispatch(getContacts(agentId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ContactAllReferral))
